import { Link } from "react-router-dom";
import { PartyPopper, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export const BirthdayTeaser = () => {
  return (
    <section className="py-16 lg:py-20 bg-[#0A0A0A]">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative bg-gradient-to-br from-[#c1ff72]/10 via-[#1A1A1A] to-[#1A1A1A] border border-[#c1ff72]/20 p-8 md:p-12 overflow-hidden">
          {/* Background decoration */}
          <div className="absolute top-0 right-0 w-32 h-32 bg-[#c1ff72]/5 rounded-full blur-3xl" />
          <div className="absolute bottom-0 left-0 w-24 h-24 bg-[#c1ff72]/5 rounded-full blur-2xl" />
          
          <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-8">
            {/* Content */}
            <div className="text-center md:text-left">
              <div className="inline-flex items-center gap-2 mb-4">
                <PartyPopper className="w-6 h-6 text-[#c1ff72]" />
                <span className="text-[#c1ff72] text-sm font-semibold uppercase tracking-wider">
                  Kindergeburtstag
                </span>
              </div>
              
              <h3 className="font-['Bebas_Neue'] text-3xl md:text-4xl lg:text-5xl text-white mb-4">
                FUSSBALL-GEBURTSTAGE ⚽🎉
              </h3>
              
              <p className="text-[#A1A1AA] text-lg max-w-xl">
                Unvergessliche Fußball-Geburtstage mit Training, Spielen und jeder Menge Spaß.
              </p>
            </div>
            
            {/* CTA Button */}
            <Button
              asChild
              className="bg-[#c1ff72] hover:bg-[#d4ff9a] text-[#0A0A0A] font-semibold px-8 py-6 rounded-none transition-all duration-300 hover:shadow-[0_0_30px_rgba(193,255,114,0.4)] whitespace-nowrap group"
            >
              <Link to="/geburtstag" data-testid="birthday-teaser-button">
                MEHR ERFAHREN
                <ChevronRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BirthdayTeaser;
